import { render, staticRenderFns } from "./client-item.vue?vue&type=template&id=84f73e3c&scoped=true&"
import script from "./client-item.vue?vue&type=script&lang=js&"
export * from "./client-item.vue?vue&type=script&lang=js&"
import style0 from "./client-item.vue?vue&type=style&index=0&id=84f73e3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f73e3c",
  null
  
)

export default component.exports